<template>
  <div class="Auth">
    <el-container>
      <el-header style="position: relative">
        <div class="header h100">
          <div class="head-left">
            <div
              class="logo d-flex j-center a-center santa"
              style="color: #000 !important"
            >
              后台管理系统
            </div>
          </div>

          <headNav :MenuList="menuList" @goDetail="goDetail"></headNav>
          <div
            class="images"
            @click="passwordDialog = true"
            style="
              cursor: pointer;
              position: absolute;
              right: 60px;
              color: #000;
              padding: 10px;
              margin-right: 55px;
              font-size: 16px;
            "
          >
            超级管理员
          </div>
          <div
            @click="logout"
            class="images"
            style="position: absolute; right: 60px; color: #000; padding: 10px"
          >
            <img
              src="@/assets/images/exit.png"
              title="退出登录"
              alt=""
              style="cursor: pointer; width: 20px; height: 20px"
            />
          </div>
        </div>
      </el-header>

      <el-container>
        <el-aside>
          <el-menu
            :default-active="$route.name"
            class="el-menu-vertical-demo"
            @select="onChangeItem"
            :collapse="isCollapse"
            unique-opened
            background-color="#fff"
            text-color="#fff"
          >
            <label v-for="(item, index) in menuList" :key="index + ''">
              <el-menu-item
                v-if="item.children.length == 0"
                :index="item.target"
              >
                <template slot="title">
                  <img :src="item.photoUri" alt="" style="margin-right: 12px" />
                  <span
                    v-if="item.id == 44"
                    slot="title"
                    @click="itemClick(item)"
                    ><i class="iconfont">&#xe6fd;</i></span
                  >
                  <span v-else slot="title" @click="itemClick(item)"
                    ><i class="iconfont">&#xe64c;</i></span
                  >
                </template>
              </el-menu-item>
            </label>
          </el-menu>
        </el-aside>
        <el-main>
          <div style="height: 32px; background-color: #fff" >
            <el-tag
              v-for="(tag,index) in tags"
              :hit="$route.path.includes(tag.fakePath)"
              :key="index"
              closable
              :type="tag.type"
              @close="closeHandle(tag)"
              @click="clickHandle(tag)"
              :disable-transitions=true
            >
              {{ tag.name }}
            </el-tag>
          </div>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      title="密码修改"
      :visible.sync="passwordDialog"
      @before-close="cancelEditPassword"
    >
      <el-input
        placeholder="请输入密码"
        v-model="password"
        show-password
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelEditPassword" type="danger">取 消</el-button>
        <el-button type="danger" @click="confirmEditPassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import { modifyPassword } from "../../api/serviceRequestAdmin";
import headNav from "./components/nav.vue";

export default {
  data() {
    return {
      tags: [],
      // isActivity: true,
      isCollapse: false,
      menuList: [],
      passwordDialog: false,
      password: "",
      visible: false,
      runOrder: [],
      // userType: "",
      userInfo: {},
      marker: "",
      menuIds: [],
      ServicesListNum: 0,
      DeliveryOrderNum: 0,
      SparePartsManagementNum: 0,
    };
  },
  components: {
    headNav,
  },
  created() {
    let menuList = [
      {
        children: "",
        id: 44,
        level: 1,
        nameCn: "会议管理",
        parentId: 21,
        permission: "",
        photoUri: "/img/eng.png",
        sort: 15,
        tag: "3605722066",
        target: "Index",
        fakePath: "auth",
      },
      {
        children: "",
        id: 45,
        level: 1,
        nameCn: "签到管理",
        parentId: 22,
        permission: "",
        photoUri: "/img/eng.png",
        sort: 15,
        tag: "3605722066",
        target: "IndexSignIn",
        fakePath: "sign",
      },
    ];
    this.menuList = menuList;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // this.userType = userInfo.userType;
    this.userInfo = userInfo;
  },
  methods: {
    clickHandle(tag) {
      console.log(tag)
      this.$router.push({
        name: tag.target
      })
    },
    closeHandle(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.$router.push({
        name: this.tags[0].target
      })
    },
    cancelEditPassword() {
      this.password = "";
      this.passwordDialog = false;
    },
    async confirmEditPassword() {
      if (this.password.trim() == "") {
        this.$message.error("密码不可以留空！");
        return;
      }
      console.log(localStorage.getItem("userInfo"));
      const res = await modifyPassword({
        id: JSON.parse(localStorage.getItem("userInfo")).userId,
        pwd: this.password,
      });
      if (res.status == 200) {
        this.$message.success("修改成功！");
        this.cancelEditPassword();
      } else {
        this.$message.error("修改密码失败！请重试！");
      }
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("menuList");
      this.$router.push({
        path: "/login",
      });
    },
    goDetail(id,target,nameCn,fakePath) {
      this.$router.push({
        name: target,
       
      });
      let tagObj = {
        name: nameCn,
        type: 'info',
        target,
        id,
        fakePath
      }
        const res = this.tags.find(tag => tag.id == id)
        console.log(res)
        if(res === undefined) {
          this.tags.push(tagObj)
        }
     
    },
    onChangeItem(currentName) {
      let { name } = this.$route;
      if (currentName == name) {
        console.warn("当前路由已经打开");
        return;
      } else {
        this.$router.push({
          name: currentName,
        });
      }
    },
    itemClick(item) {
      console.log(item)
        let tagObj = {
          name: item.nameCn,
          type: 'info',
          target: item.target,
          id: item.id
        }
      if (item.nameCn === "会议管理") {
        this.$router.push("/auth/Index");

        const res = this.tags.find(tag => tag.id == item.id)
        console.log(res)
        if(res === undefined) {
          this.tags.push(tagObj)
        }
        // this.tags.push({name: item.nameCn,type: ''})
      } else if (item.nameCn === "签到管理") {
        this.$router.push("/sign/IndexSignIn");
        // this.tags.push({name: item.nameCn,type: ''})
        const res = this.tags.find(tag => tag.id == item.id)
        console.log(res)
        if(res === undefined) {
          this.tags.push(tagObj)
        }

      }
    },

  },
  
};
</script>

<style lang="less">
.Auth {
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    > .head-right {
      div {
        cursor: pointer;
      }
    }
    > .head-left {
      height: 100%;
      width: 245px;
      > .logo {
        height: 100%;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 20px;
        img {
          display: block;
          height: 40px;
          width: 120px;
          margin-right: 84px;
        }
      }
    }
  }
}

.collapse {
  width: 100%;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4a5064;
  padding: 15px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-height: 400px;
}
.el-menu {
  border-right: none;
}
.iconfont {
  margin-right: 10px;
}
.el-header {
  // background-color: #545c64 !important;
  height: 60px !important;
  padding: 0;
  border-bottom: 1px solid rgba(0, 21, 41, 0.08);
}
.el-aside {
  width: 64px !important;
  // background-color: #545c64 !important;
  border-right: 1px solid rgba(0, 21, 41, 0.08);
  height: calc(100vh - 60px);
}
.Auth .el-main {
  background-color: #fff !important;
  padding: 0 !important;
  height: calc(100vh - 60px);
}
.el-container.is-vertical {
  height: 100%;
}
.el-dialog__header {
  background-color: #006ec7;
  border-radius: 8px 8px 0 0 !important;
}
.el-dialog {
  border-radius: 8px !important;
}
.el-step__head.is-finish {
  color: #006ec7 !important;
  border-color: #006ec7;
}
.el-step__title.is-finish {
  color: #006ec7;
}
.el-step__description.is-finish {
  color: #006ec7;
}
.el-submenu__title:hover {
  background-color: #fff !important;
}
.el-menu-item {
  min-height: 60px;
  line-height: 60px;
  padding: 0 32px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--danger,
.el-button,
.el-button--info {
  background-color: #409eff;
  border-collapse: #409eff;
  color: #fff;
}
.el-menu--inline {
  padding: 0 40px !important;
}
.el-badge__content {
  background-color: #de1e23;
}
// .el-menu-item.is-active {
//   color: #fff !important;
//   background-color: rgb(67, 74, 80) !important;
// }
.el-pagination__jump {
  font-size: 0.875rem !important;
}
.el-form-item__label {
  font-size: 0.875rem !important;
}
body {
  font-size: 0.875rem;
}
.logoo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #ddd;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.red {
  color: #de1e23;
}
.el-menu .marker {
  font-size: 12px;
  color: #de1e23;
}
.el-menu-item {
  text-align: center;
}
.el-table__header thead tr th {
  background-color: #fff !important;
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-tag {
  cursor: pointer;
}
.el-main .activeTitle {
    background-color: #aaa;
    color: #fff;
  }
</style>
